import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export const Container = styled(Row)<{ type: 'warning' | 'danger' }>`
  background-color: ${({ theme, type = 'warning' }) => theme.colors[type]};
  color: white;
  padding: 20px;
  align-items: center;
  border-radius: 4px;
  font-weight: 700;
  white-space: pre-line;
`;
